import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { toast } from "react-toastify";
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx";

const OccupancyReport = () => {
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const ITEMS_PER_PAGE = 100
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [unitClass, setUnitClass] = useState([]);
    const [loader, setLoader] = useState(false);
    const [tanentList, setTanentList] = useState([]);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        floor: "",
        unitNo: "",
        availableCheck: false,
        reserved: false,
        all: true,
        leased: false,
        unitClass: "",
        noticeCheck: false,
        blocked: false,
        approval: false,
        bedroom: "",
        view: "",
        tanent: "",
        asOf: "",
        landloard: "",
        prospectlevel: "",
    })
    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setFormData((prev) => ({ ...prev, asOf: formattedDate }));
    }, []);

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRSearchPropertyNos,LRSearchUnitClass,LRSearchCustomerName,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(addAllOption(res?.data?.dropdowns?.PropertyNo));
            setUnitClass(addAllOption(res?.data?.dropdowns?.UnitClass));
            setTanentList(addAllOption(res?.data?.dropdowns?.CustomerName));
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getStatusParam = (formData) => {
        const statusMap = [
            { key: "reserved", value: "Reserved" },
            { key: "blocked", value: "Blocked" },
            { key: "leased", value: "Leased" },
            { key: "availableCheck", value: "Available" },
            { key: "noticeCheck", value: "On Notice" },
            { key: "approval", value: "Sold" }, // or whatever backend expects
        ];

        const selectedStatuses = statusMap
            .filter(item => formData[item.key])
            .map(item => item.value);

        return selectedStatuses.length > 0
            ? selectedStatuses.join("|")
            : "All";
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            const params = new URLSearchParams();
            // let fromdate = moment(formData?.asOf || formattedDate).add(1, "day").format("DD-MMM-YYYY");
            let fromdate = moment(formData?.asOf || formattedDate).format("DD-MMM-YYYY");
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("unitAvailabilityRequest.AsOf", fromdate);
            params.append("unitAvailabilityRequest.Status", getStatusParam(formData));
            params.append("unitAvailabilityRequest.UnitView", formData?.view?.label || "All");
            params.append("unitAvailabilityRequest.LandlordId", formData?.landloard?.label || "All");
            params.append("unitAvailabilityRequest.IsReserved", formData?.reserved || false);
            params.append("unitAvailabilityRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("unitAvailabilityRequest.Floor", formData?.floor?.label || "All");
            params.append("unitAvailabilityRequest.UnitClass", formData?.unitClass?.label || "All");
            params.append("unitAvailabilityRequest.Bedrooms", formData?.bedroom?.label || "All");
            params.append("unitAvailabilityRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("unitAvailabilityRequest.CustomerNo", formData?.tanent?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_UNIT", `?${params.toString()}`);
            if (res?.data?.result) {
                let data = res?.data?.result || []
                // const propertywise = data?.filter(fil => fil?.property_Name === formData?.property?.label)
                setRowData(data || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)

            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            const params = new URLSearchParams();
            let fromdate = moment(formData?.asOf || formattedDate).format("DD-MMM-YYYY")
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("unitAvailabilityRequest.AsOf", fromdate);
            params.append("unitAvailabilityRequest.Status", getStatusParam(formData));
            params.append("unitAvailabilityRequest.UnitView", formData?.view?.label || "All");
            params.append("unitAvailabilityRequest.LandlordId", formData?.landloard?.label || "All");
            params.append("unitAvailabilityRequest.IsReserved", formData?.reserved || false);
            params.append("unitAvailabilityRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("unitAvailabilityRequest.Floor", formData?.floor?.label || "All");
            params.append("unitAvailabilityRequest.UnitClass", formData?.unitClass?.label || "All");
            params.append("unitAvailabilityRequest.Bedrooms", formData?.bedroom?.label || "All");
            params.append("unitAvailabilityRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("unitAvailabilityRequest.CustomerNo", formData?.tanent?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_UNIT", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const emptyZeroFormatter = (params) => {
        return params.value === 0 || params.value === "0" ? "" : params.value;
    };
    const columnDefs = [
        {
            headerName: "Property", field: "property_Name",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left",
        },
        {
            headerName: "Unit No", field: "unit_No",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100, pinned: "left"
        },
        {
            headerName: "Status", field: "status",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100, pinned: "left"
        },
        {
            headerName: "Unit Class", field: "unit_Class",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150,
        },
        {
            headerName: "Customer", field: "customerName",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150,
        },
        {
            headerName: "Lease Date", field: "leaseDate",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 136,
        },
        {
            headerName: "Lease No", field: "leaseNo",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 136,
        },
        {
            headerName: "End Date", field: "leaseExpiry",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 136,
        },
        {
            headerName: "Floor", field: "floor",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100,
        },
        {
            headerName: "B/R", field: "bedrooms",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100,
        },
        // { headerName: "Rent/Month", field: "total_Value", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        // { headerName: "Sec. Deposit", field: "premium_Amt", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        {
            headerName: "Rent for Period", field: "roundOff_Value",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150,
        },
        // { headerName: "Elect Limit", field: "electLimit", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        // { headerName: "Company Name", field: "companyName", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        {
            headerName: "Contact No", field: "contactNo",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150,
        },
        {
            headerName: "Email", field: "emailID",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 200,
        },
        {
            headerName: "Nationality", field: "nationality",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150,
        },
        {
            headerName: "Designation", field: "designation",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100,
        },
        {
            headerName: "Persons Staying", field: "noOfPersons",
            valueFormatter: emptyZeroFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100,
        },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            property: "",
            unitNo: "",
            availableCheck: false,
            reserved: false,
            leased: false,
            unitClass: "",
            noticeCheck: false,
            blocked: false,
            approval: false,
            tanent: "",
            landloard: "",
            prospectlevel: "",
            asOf: todate,
        });
        setUnitList([])
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null, floor: null }));

            const propertyValue = value?.value === 'All' ? null : value?.value;

            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
        }

        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => value === 0 || value === "0" || value === null || value === undefined ? "" : value;

    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");
        const columns = [
            { header: "Property", key: "property_Name" },
            { header: "Unit No", key: "unit_No" },
            { header: "Customer", key: "customerName" },
            { header: "Lease Date", key: "leaseDate" },
            { header: "End Date", key: "leaseExpiry" },
            { header: "B/R", key: "bedrooms" },
            { header: "Rent / Month", key: "total_Value" },
            { header: "Sec. Deposit", key: "premium_Amt" },
            { header: "Company Name", key: "companyName" },
            { header: "Contact No", key: "contactNo" },
            { header: "Email", key: "emailID" },
            { header: "Status", key: "status" },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Lease Occupancy Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment(formData?.asOf).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.key]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            columnStyles: {
                6: { halign: "right" },
                7: { halign: "right" },
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });

        doc.save("Lease_Occupancy_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const title = "LEASE OCCUPANCY REPORT";

        const columns = [
            { header: "Property", field: "property_Name" },
            { header: "Unit No", field: "unit_No" },
            { header: "Customer", field: "customerName" },
            { header: "Lease Date", field: "leaseDate", type: "date" },
            { header: "End Date", field: "leaseExpiry", type: "date" },
            { header: "B/R", field: "bedrooms" },
            { header: "Rent / Month", field: "total_Value", type: "number", align: "right" },
            { header: "Sec. Deposit", field: "premium_Amt", type: "number", align: "right" },
            { header: "Company Name", field: "companyName" },
            { header: "Contact No", field: "contactNo" },
            { header: "Email", field: "emailID" },
            { header: "Status", field: "status" },
        ];

        const dataRows = exportData.map(item =>
            columns.map(col => normalizeValue(item[col.field]))
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            columns.map(c => c.header),
            ...dataRows,
        ]);

        // Merge Title
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
        ];

        // Auto column width
        worksheet["!cols"] = columns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] || "").length)
            );
            return { wch: maxLength + 4 };
        });

        // Freeze header
        worksheet["!freeze"] = { ySplit: 2 };

        // Border style with color
        const borderStyle = {
            top: { style: "thin", color: { rgb: "FF000000" } },
            bottom: { style: "thin", color: { rgb: "FF000000" } },
            left: { style: "thin", color: { rgb: "FF000000" } },
            right: { style: "thin", color: { rgb: "FF000000" } },
        };

        // Title style
        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FF333333" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            };
        }

        // Header style
        columns.forEach((_, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;

            cell.s = {
                font: { bold: true, sz: 11, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF7E57C2" } },
                alignment: { horizontal: "center", vertical: "center" },
                border: borderStyle,
            };
        });

        // Data cells
        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;

                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: col.align || "left" },
                    border: borderStyle,
                };

                if (col.type === "number") {
                    cell.t = "n";
                    cell.z = "#,##0.00";
                }

                if (col.type === "date") {
                    cell.z = "dd-mmm-yyyy";
                }
            });
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Occupancy");

        XLSX.writeFile(workbook, "Occupancy_Report.xlsx");
    };
    const handleCheckChange = (name, checked) => {
        setFormData(prev => {
            if (name === "all") {
                return {
                    ...prev,
                    all: checked,
                    availableCheck: false,
                    leased: false,
                    blocked: false,
                };
            }

            return {
                ...prev,
                [name]: checked,
                all: false,
            };
        });
    };

    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList
                                        ?.sort((a, b) => a.text.localeCompare(b.text))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit Class</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitClass}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitClass', value: selectedOption })}
                                    options={unitClass?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tanent}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tanent", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">As of</label>
                                <DatePicker
                                    selected={formData.asOf}
                                    onChange={(date) => handleDateChange({ name: 'asOf', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex justify-content-between center gap-5">
                                <div className="d-flex gap-3">
                                    <label className="form-check-label">
                                        All
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="all"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.all}
                                        onChange={(e) => handleCheckChange("all", e.target.checked)}
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label className="form-check-label">Available</label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="availableCheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.availableCheck}
                                        onChange={(e) => handleCheckChange("availableCheck", e.target.checked)}
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label className="form-check-label">
                                        Leased
                                    </label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="leased"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.leased}
                                        onChange={(e) => handleCheckChange("leased", e.target.checked)}
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label className="form-check-label">Blocked</label>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="blocked"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.blocked}
                                        onChange={(e) => handleCheckChange("blocked", e.target.checked)}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">

                                <div className="d-flex gap-1">
                                    {loader === true ?
                                        <div className='mainbtnGry flex-end gap-2 w-50'>
                                            <ClipLoader color="#ffffff" className='mt-1' size={20} />
                                        </div>
                                        :
                                        <div
                                            onClick={() => getItems()}
                                            className="mainbtnGry flex-end gap-2 w-50"
                                        >
                                            <FaFileCircleExclamation
                                                color="#fff"
                                                className="center mt-1 mx-2"
                                            />
                                            <div className="center">Search</div>
                                        </div>
                                    }
                                    <div
                                        onClick={() => handleClearFilters()}
                                        className="mainbtnRed flex-end gap-2 w-50"
                                    >
                                        <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Reset</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Available Unit List</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default OccupancyReport;
